export default "/images/vendor/flag-icon-css/flags/1x1/py.svg?f95e744f8dc1060e28c92e7afc8644da";